import { inject } from "@angular/core";
import { CanActivateFn, Route, Router } from "@angular/router";
import { AuthScreenComponent } from "src/app/auth/auth.component";
import { LoginComponent } from "src/app/components/default/login/login.component";
import { DefaultComponent } from "src/app/default.component";
import { LoggedOutComponent } from "src/app/logged-out/logged-out.component";
import { RecoveryComponent } from "src/app/recovery/recovery.component";
import { UnsecureContentComponent } from "src/app/unsecure/unsecure-content/unsecure-content.component";
import { IsNotAuthenticatedGuard } from "../guards/is-not-authenticated.guard";

export const lflRedirectGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const id = route.queryParamMap.get("id");

  return router.createUrlTree(["/login", id]);
};

export const ROUTES: Route[] = [
  {
    path: "app",
    loadChildren: () => import("./secure.routes").then((mod) => mod.SECURE_ROUTES),
  },
  {
    path: "",
    component: AuthScreenComponent,
    children: [
      {
        path: "",
        pathMatch: "full",
        redirectTo: "login",
      },
      {
        path: "lfl",
        canActivate: [lflRedirectGuard],
        component: DefaultComponent,
      },
      {
        path: "login",
        canActivate: [IsNotAuthenticatedGuard],
        children: [
          {
            path: ":id",
            component: LoginComponent,
          },
          {
            path: "",
            component: LoginComponent,
          },
        ],
      },
      {
        path: "logout",
        component: LoggedOutComponent,
      },
      {
        path: "recover",
        canActivate: [IsNotAuthenticatedGuard],
        component: RecoveryComponent,
      },
      {
        path: "sso",
        redirectTo: "login/sso",
      },
      {
        path: "**",
        canActivate: [IsNotAuthenticatedGuard],
        component: UnsecureContentComponent,
      },
    ],
  },
];
